<template>
  <div>
    <p v-if="message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "Verify Token",
  data() {
    return {
      message: "",
    };
  },
  mounted() {
    const validate = this.$route.query.v;

    if (validate) {
      const lastVisitedURL = localStorage.getItem("lastVisitedURL") ?? "";
      localStorage.clear();
      localStorage.setItem("lastVisitedURL", lastVisitedURL);
      this.$router.push({ path: "/login", query: { v: 1 } });
      return;
    }

    // security/0.3: new signed-URL flow. Admin panel redirects to
    // /verify-token?intent=<url-encoded signed impersonation URL>. Extract
    // that URL and POST to it. The API's `signed` middleware validates the
    // HMAC + expiry; the controller enforces single-use.
    const intent = this.$route.query.intent;
    if (intent) {
      // Log out the current session before consuming the impersonation link,
      // so an admin's session cannot silently merge with the target user's.
      const lastVisitedURL = localStorage.getItem("lastVisitedURL") ?? "";
      localStorage.clear();
      localStorage.setItem("lastVisitedURL", lastVisitedURL);
      this.verifyToken(intent);
      return;
    }

    // Legacy path — old admin links used /verify-token/:token. That scheme
    // is retired (see security/0.3). Fail explicitly rather than silently.
    const legacyToken = this.$route.params.token;
    if (legacyToken) {
      this.message =
        "This login link uses a retired scheme. Ask an admin to re-issue it.";
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/home");
    }
  },
  methods: {
    redirectToLastVisited() {
      const lastVisitedURL = localStorage.getItem("lastVisitedURL") ?? "";
      if (lastVisitedURL) {
        const [path, hash] = lastVisitedURL.split("#");
        window.location.href = path + (hash ? `#${hash}` : "");
      } else {
        window.location.href = "/home";
      }
    },
    verifyToken(signedUrl) {
      this.loading = true;
      const isSso = "sso" in this.$route.query;
      if (isSso) {
        localStorage.setItem("sso", isSso);
        const now = new Date().getTime();
        localStorage.setItem("sso-check-date", now.toString());
        localStorage.setItem("sso-check", "checked");
      }
      this.$store
        .dispatch("auth/loginAsUser", signedUrl)
        .then(
          () => {
            this.redirectToLastVisited();
          },
          (error) => {
            this.loading = false;
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
    },
  },
};
</script>
